import { render, staticRenderFns } from "./openingHours.vue?vue&type=template&id=49874a14&scoped=true&"
import script from "./openingHours.vue?vue&type=script&lang=js&"
export * from "./openingHours.vue?vue&type=script&lang=js&"
import style0 from "./openingHours.vue?vue&type=style&index=0&id=49874a14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49874a14",
  null
  
)

export default component.exports